// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/backendFrontend/unwrapSelectionMarkupBe.ts

// Returns true when something was unwrapped so callers can skip a no-op blob re-upload.
export const unwrapSelectionMarkup = (root: Document | Element, commentId?: string): boolean => {
  const filter = commentId !== undefined ? `[data-comment-id="${commentId}"]` : '';
  const elements = root.querySelectorAll(`selection-mark${filter}, selection-node${filter}`);
  if (elements.length === 0) return false;
  elements.forEach((el) => {
    const fragment = el.ownerDocument.createDocumentFragment();
    while (el.firstChild) fragment.appendChild(el.firstChild);
    el.replaceWith(fragment);
  });
  return true;
};
